import { useEffect, useState, useRef } from "react";
import { Activity, X } from "lucide-react";
import { base44 } from "@/api/base44Client";

export default function AdminResourceTracker({ page }) {
  const [isAdmin, setIsAdmin] = useState(false);
  const [sessionCount, setSessionCount] = useState(0);
  const [open, setOpen] = useState(true);
  const [sessionId] = useState(() => Math.random().toString(36).slice(2, 10) + Date.now().toString(36));

  // Record session for all users, show widget to admins only
  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const user = await base44.auth.me();
        if (active) {
          if (user && user.role === "admin") {
            setIsAdmin(true);
          }
          // Record session for all users
          base44.entities.ResourceEvent.create({
            page, event_type: "session", session_id: sessionId, user_email: user?.email || "",
          }).catch(() => {});
          const sessions = await base44.entities.ResourceEvent.filter({ page, event_type: "session" }).catch(() => []);
          if (active && user && user.role === "admin") {
            setSessionCount(sessions.length || 0);
          }
        }
      } catch (_) {}
    })();
    return () => { active = false; };
  }, [page, sessionId]);

  if (!isAdmin) return null;

  return (
    <div style={{ position: "fixed", bottom: 16, right: 16, zIndex: 9999, maxWidth: 280, fontFamily: "'DM Sans', sans-serif" }}>
      <div style={{ background: "#112215", borderRadius: 14, boxShadow: "0 12px 40px rgba(0,0,0,0.3)", overflow: "hidden", border: "1px solid #333" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 16px", borderBottom: "1px solid #2a2a2a" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <Activity size={14} color="#4A6DC7" />
            <span style={{ fontSize: 12, fontWeight: 700, color: "#fff", letterSpacing: "0.02em" }}>Admin Tracking</span>
          </div>
          <button onClick={() => setOpen(o => !o)} style={{ background: "none", border: "none", cursor: "pointer", padding: 0, display: "flex" }}>
            <X size={14} color="#888" />
          </button>
        </div>
        {open && (
          <div style={{ padding: "12px 16px" }}>
            <p style={{ fontSize: 10, fontWeight: 600, letterSpacing: "0.08em", textTransform: "uppercase", color: "#888", margin: "0 0 8px" }}>Page</p>
            <p style={{ fontSize: 12, color: "#fff", margin: "0 0 14px", wordBreak: "break-all", lineHeight: 1.4 }}>{page}</p>
            <div style={{ marginBottom: 14 }}>
              <div style={{ background: "#112215", borderRadius: 8, padding: "10px", textAlign: "center" }}>
                <p style={{ fontSize: 18, fontWeight: 800, color: "#fff", margin: 0 }}>{sessionCount}</p>
                <p style={{ fontSize: 10, color: "#888", margin: "2px 0 0", textTransform: "uppercase", letterSpacing: "0.06em" }}>Sessions</p>
              </div>
            </div>
            <p style={{ fontSize: 10, color: "#555", margin: "12px 0 0", lineHeight: 1.4 }}>Only visible to logged-in admins. Sessions on this page are recorded.</p>
          </div>
        )}
      </div>
    </div>
  );
}